<template>
    <div class="mark-product">
        <print-labels :quantity="quantity" @print="printStickers">
            <label class="quantity mr-3 ml-3"
                   slot="quantity">
                Quantity:
                <b-form-input type="number" class="ml-1" v-model.number="quantity"/>
            </label>
        </print-labels>
        <div class="d-flex flex-column align-items-center mt-5">
            <img src="~img/barcode.png" alt="barcode">
            <h2 class="mt-3">{{product.fnsku}}</h2>
            <h2 class="mt-4">{{product.name}}</h2>
        </div>
    </div>
</template>

<script>
    import PrintLabels from '~cp/UserPanel/Elements/PrintLabels'
    import {getPDF} from 'api/services'

    export default {
        name: 'MarkProduct',
        components: {
            PrintLabels
        },
        data() {
            return {
                id: this.$route.params.id,
                product: {},
                quantity: 0
            }
        },
        created() {
            this.getProductInfo()
        },
        methods: {
            getProductInfo() {
                this.$api('GET', this.$endpoints.singleProduct(this.id)).then(response => { this.product = response })
            },
            printStickers(data) {
                getPDF(this.$endpoints.printProduct(this.id), data, 'barcodes').then()
            }
        }
    }
</script>

<style lang="scss">
    .quantity {
        display: inline-flex;
        align-items: center;
        margin: 0;

        input {
            max-width: 125px;
        }
    }

    .mark-product {
        h2 {
            font-size: 30px;
            color: #161616;
            font-weight: bold;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Inventory/Management/MarkProduct.vue